<template>
  <div class="index-wrap">
    <IndexHeader :user="user" />
    <div class="index-label">
      <img :src="require('@/assets/img/label-icon.png')" />
      <img class="time-icon" :src="require('@/assets/img/time-icon.png')" />
      <img class="sub-icon" :src="require('@/assets/img/sub-title-icon.png')" />
    </div>
    <div class="menu-wrap">
      <van-row type="flex" justify="space-between" align="center" :gutter="10">
        <van-col>
          <div class="menu-item bg-1" @click="$router.push('/rule')"></div>
        </van-col>
        <van-col>
          <div class="menu-item-center bg-2" @click="toCompetition"></div>
        </van-col>
        <van-col>
          <div class="menu-item bg-3" @click="$router.push('/print')"></div>
        </van-col>
      </van-row>
    </div>
    <!-- <div class="info-wrap">
      <van-row type="flex" justify="space-between">
        <van-col span="5">
          <div class="info-label">主办单位：</div>
        </van-col>
        <van-col span="19">
          <div class="info-text">
            省科协、省农业农村厅、省教育厅、省民政厅、省总工会
          </div>
        </van-col>
      </van-row>
      <van-row type="flex" justify="space-between">
        <van-col span="5">
          <div class="info-label">技术支持：</div>
        </van-col>
        <van-col span="19">
          <div class="info-text">中科数创(北京)数字传媒有限公司</div>
        </van-col>
      </van-row>
    </div> -->
    <div class="host-wrap">
      <img :src="require('@/assets/img/host-icon.png')" />
    </div>
    <div class="invite-btn-wrap" @click="$router.push('/invite')">
      <span>邀请好友赢红包</span>
    </div>
    <!-- 统一参赛信息对话框 -->
    <van-dialog
      v-model="infoDialog"
      class="area-dialog"
      :title="infoDialogMode === 'add' ? '用户参赛信息' : '用户参赛信息确认'"
      :show-confirm-button="false"
      :show-cancel-button="false"
      close-on-click-overlay
    >
      <div class="area-dialog_content">
        <div v-if="infoDialogMode === 'change'" class="edit-hint">
          可修改以下信息
        </div>
        <van-field
          class="area-field edit-field"
          v-model="infoUserName"
          maxlength="30"
          label="真实姓名"
          placeholder="请输入真实姓名"
          input-align="right"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoFieldValue"
          is-link
          readonly
          label="所在地区"
          placeholder=""
          input-align="right"
          center
          @click="openInfoAreaPicker"
        />
        <van-field
          label="所属社区、村"
          readonly
          :border="false"
          style="padding-bottom: 0"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoVillage"
          label=""
          maxlength="50"
          placeholder='请填写全称，没有可填写为"无"'
          input-align="right"
        />
        <van-field
          label="注册单位名称"
          readonly
          :border="false"
          style="padding-bottom: 0"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoUnit"
          label=""
          maxlength="50"
          placeholder='请填写全称，没有可填写为"无"'
          input-align="right"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoCrowdRender"
          is-link
          readonly
          label="人群类别"
          placeholder=""
          input-align="right"
          center
          @click="openInfoCrowdPicker"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoAgeRender"
          is-link
          readonly
          label="您的年龄"
          placeholder="请选择年龄"
          input-align="right"
          center
          @click="openInfoAgePicker"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoPhone"
          type="tel"
          maxlength="11"
          label="手机号"
          placeholder="请输入参赛手机号"
          input-align="right"
        />
        <van-field
          class="area-field edit-field"
          v-model="infoSms"
          center
          type="digit"
          maxlength="4"
          placeholder="请输入短信验证码"
        >
          <template #button>
            <van-button
              size="small"
              type="info"
              round
              @click="sendInfoVerifyCode"
              :disabled="infoSended"
              >{{ infoSended ? infoCountTime : "获取验证码" }}</van-button
            >
          </template>
        </van-field>
      </div>
      <div class="change-info-footer">
        <van-button
          v-if="infoDialogMode === 'add'"
          class="footer-btn cancel-btn"
          plain
          type="default"
          @click="infoDialog = false"
          >取消</van-button
        >
        <van-button class="footer-btn" type="info" @click="submitInfo">{{
          infoDialogMode === "add" ? "提交" : "确认信息"
        }}</van-button>
      </div>
    </van-dialog>
    <van-dialog v-model="userLocationDialog" class="custom-dialog">
      <div class="custom-dialog-main">
        <div class="custom-dialog-title">提示</div>
        <div class="custom-dialog-content">
          很遗憾，您当前的位置为【{{
            provinceName
          }}】，不在竞赛区域（山西省）内，无法参加本次活动
        </div>
      </div>
    </van-dialog>
    <van-popup v-model="showAreaPicker" round position="bottom">
      <van-cascader
        v-model="areaValue"
        title="请选择所在地区"
        :options="options"
        active-color="#1989fa"
        @close="showAreaPicker = false"
        @change="onChange"
        @finish="onFinish"
        :field-names="fieldNames"
      />
    </van-popup>

    <van-popup v-model="showCrowdPicker" round position="bottom">
      <van-picker
        title="请选择职业"
        show-toolbar
        :columns="crowds"
        @confirm="crowdConfirm"
        @cancel="showCrowdPicker = false"
      />
    </van-popup>
    <van-popup v-model="showAgePicker" round position="bottom">
      <van-picker
        title="请选择年龄"
        show-toolbar
        :columns="ages"
        @confirm="ageConfirm"
        @cancel="showAgePicker = false"
      />
    </van-popup>
    <div v-if="time > 0 && showCountDown" class="time-count">
      <p>距离开赛还有</p>
      <van-count-down :time="time" @finish="countDownFinish">
        <template #default="timeData">
          <div class="count-unit">
            <span
              class="block"
              v-for="(num, i) in splitNum(timeData.days)"
              :key="'d' + i"
              >{{ num }}</span
            >
            <span class="unit">天</span>
          </div>
          <div class="count-unit">
            <span
              class="block"
              v-for="(num, i) in splitNum(timeData.hours)"
              :key="'h' + i"
              >{{ num }}</span
            >
            <span class="unit">时</span>
          </div>
          <div class="count-unit">
            <span
              class="block"
              v-for="(num, i) in splitNum(timeData.minutes)"
              :key="'m' + i"
              >{{ num }}</span
            >
            <span class="unit">分</span>
          </div>
          <div class="count-unit">
            <span
              class="block"
              v-for="(num, i) in splitNum(timeData.seconds)"
              :key="'s' + i"
              >{{ num }}</span
            >
            <span class="unit">秒</span>
          </div>
        </template>
      </van-count-down>
    </div>
  </div>
</template>
<script>
import { getLocation } from "@/utils/share";
import { Dialog } from "vant";
import IndexHeader from "@/components/IndexHeader.vue";
export default {
  components: { IndexHeader },
  data() {
    return {
      infoDialog: false,
      infoDialogMode: "add",
      userLocationDialog: false,
      infoCityCode: "",
      infoCountyCode: "",
      infoTownCode: "",
      provinceName: "",
      infoUserName: "",
      cityList: [],
      countyList: [],
      infoPhone: "",
      infoSms: "",
      infoAge: "",
      infoAgeRender: "请选择",
      showAgePicker: false,
      showAreaPicker: false,
      areaValue: "",
      options: [{ name: "山西省", code: "140000000000", children: [] }],
      infoFieldValue: "请选择",

      fieldNames: {
        text: "name",
        value: "code",
        children: "children",
      },
      infoCountTime: 300,
      infoSended: false,
      items: [],
      crowds: [
        { key: 1, text: "青少年" },
        { key: 2, text: "农民" },
        { key: 3, text: "老年人" },
        { key: 4, text: "产业工人" },
        { key: 5, text: "领导干部和公务员" },
      ],
      ages: [
        { key: 1, text: "18岁以下" },
        { key: 2, text: "18-29岁" },
        { key: 3, text: "30-39岁" },
        { key: 4, text: "40-49岁" },
        { key: 5, text: "50-59岁" },
        { key: 6, text: "60-69岁" },
        { key: 7, text: "69岁以上" },
      ],
      showCrowdPicker: false,
      infoCrowdRender: "请选择",
      infoCrowd: "",
      infoUnit: "",
      infoVillage: "",
      time:
        new Date("2026/09/01 00:00:00").getTime() -
        Number(new Date().getTime()),
      showCountDown: true,
    };
  },
  computed: {
    user() {
      return this.$store.state.user?.user;
    },
  },
  methods: {
    // 跳转竞赛答题
    async toCompetition() {
      if (new Date().getTime() < new Date("2026/08/01 00:00:00").getTime()) {
        this.$notify({
          type: "danger",
          message: "活动未开始",
          duration: 2000,
        });
      } else {
        if (this.user && this.user.nickname) {
          if (
            this.user.province_code &&
            this.user.province_code != "0" &&
            this.user.province_code == 140000000000 &&
            this.user.city_code &&
            this.user.city_code != "0"
          ) {
            if (this.user.is_change == 1) {
              this.openInfoDialog("change");
            } else {
              this.$router.push("/competition");
            }
          } else {
            getLocation(async (longitude, latitude, msg) => {
              console.log(longitude, latitude, msg);
              if (longitude && latitude) {
                try {
                  const res = await this.$axios.post(`/User/getLocal`, {
                    longitude: longitude,
                    latitude: latitude,
                  });
                  if (res.data.province == "山西省") {
                    // if (res.data.province == "山西省") {
                    this.openInfoDialog("add");
                  } else {
                    this.provinceName = res.data.province;
                    this.userLocationDialog = true;
                  }
                  console.log(res);
                } catch (error) {
                  this.$notify({
                    type: "danger",
                    message: error.errorMsg || "定位失败！",
                    duration: 2000,
                  });
                  console.log(error);
                }
              } else {
                console.log(msg);
                this.$notify({
                  type: "danger",
                  message: "获取位置信息失败,请确保您的手机定位权限已开启",
                  duration: 2000,
                });
              }
            });
          }
        } else {
          this.$notify({
            type: "danger",
            message: "认证失败，请确定您已授权",
            duration: 2000,
          });
        }
      }
    },
    async loadArea(level, code = "140000000000") {
      try {
        const res = await this.$axios.post(`/Region/getRegionList`, {
          level: level,
          code: code,
        });
        if (level == 2 || level == 3) {
          this.items = (res.data ?? []).map((item) => {
            item.children = [];
            return item;
          });
        } else {
          this.items = res.data ?? [];
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          message: error.errorMsg || "获取地区信息失败！",
          duration: 2000,
        });
        return [];
      }
    },
    onChange({ tabIndex, selectedOptions, value }) {
      if (tabIndex == 0) {
        this.loadArea(2).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      } else if (tabIndex == 1 && value) {
        this.loadArea(3, value).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      } else if (tabIndex == 2 && value) {
        this.loadArea(4, value).then(() => {
          selectedOptions[tabIndex].children = this.items;
        });
      }
    },
    onFinish({ selectedOptions }) {
      this.showAreaPicker = false;
      this.infoCityCode = selectedOptions[1].code;
      this.infoCountyCode = selectedOptions[2].code;
      this.infoTownCode = selectedOptions[3].code;
      this.infoFieldValue = selectedOptions.map((item) => item.name).join(" ");
    },
    crowdConfirm(value) {
      this.infoCrowd = value.key;
      this.infoCrowdRender = value.text;
      this.showCrowdPicker = false;
    },
    ageConfirm(value) {
      this.infoAge = value.key;
      this.infoAgeRender = value.text;
      this.showAgePicker = false;
    },
    async sendInfoVerifyCode() {
      if (!this.infoPhone.trim()) {
        this.$toast.fail("请输入手机号");
        return false;
      } else if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.infoPhone.trim())) {
        this.$toast.fail("请输入正确格式的手机号");
        return false;
      } else {
        try {
          await this.$axios.post(`/User/sendSms`, {
            mobile: this.infoPhone,
          });
          this.infoCountTime = 300;
          this.infoSended = true;
          const timer = setInterval(() => {
            this.infoCountTime--;
            if (this.infoCountTime <= 0) {
              this.infoSended = false;
              clearInterval(timer);
            }
          }, 1000);
        } catch (error) {
          this.$notify({
            type: "danger",
            message: error.errorMsg || "发送失败",
            duration: 2000,
          });
          console.log(error);
        }
      }
    },
    countDownFinish() {
      this.showCountDown = false;
    },
    splitNum(num) {
      return String(num).padStart(2, "0").split("");
    },
    openInfoDialog(mode) {
      this.infoDialog = false;
      this.infoDialogMode = mode;
      this.$nextTick(() => {
        if (mode === "change") {
          this.infoUserName = this.user.name || "";
          this.infoVillage = this.user.village || "";
          this.infoUnit = this.user.unit || "";
          this.infoPhone = this.user.mobile || "";
          this.infoAge = this.user.age || "";
          this.infoAgeRender = this.getAgeText(this.user.age) || "请选择";
          this.infoCrowd = this.user.crowd || "";
          this.infoCrowdRender = this.getCrowdText(this.user.crowd) || "请选择";
          this.infoFieldValue = this.getAreaText() || "请选择";
          this.infoCityCode = this.user.city_code || "";
          this.infoCountyCode = this.user.county_code || "";
          this.infoTownCode = this.user.town_code || "";
        } else {
          this.infoUserName = "";
          this.infoVillage = "";
          this.infoUnit = "";
          this.infoPhone = "";
          this.infoAge = "";
          this.infoAgeRender = "请选择";
          this.infoCrowd = "";
          this.infoCrowdRender = "请选择";
          this.infoFieldValue = "请选择";
          this.infoCityCode = "";
          this.infoCountyCode = "";
          this.infoTownCode = "460105001000";
        }
        this.infoSms = "";
        this.infoSended = false;
        this.infoCountTime = 300;
        this.infoDialog = true;
      });
    },
    openInfoAreaPicker() {
      this.showAreaPicker = true;
    },
    openInfoCrowdPicker() {
      this.showCrowdPicker = true;
    },
    openInfoAgePicker() {
      this.showAgePicker = true;
    },
    getAreaText() {
      const parts = [
        this.user.city_name,
        this.user.county_name,
        this.user.town_name,
      ].filter(Boolean);
      return parts.join(" ");
    },
    getCrowdText(key) {
      const item = this.crowds.find((c) => c.key == key);
      return item ? item.text : "";
    },
    getAgeText(key) {
      const item = this.ages.find((a) => a.key == key);
      return item ? item.text : "";
    },

    async submitInfo() {
      if (!this.infoUserName.trim()) {
        this.$toast.fail("请输入姓名");
        return;
      }
      if (
        !this.infoCityCode.trim() ||
        !this.infoCountyCode.trim() ||
        !this.infoTownCode.trim()
      ) {
        this.$toast.fail("请选择地区信息");
        return;
      }
      if (!this.infoVillage.trim()) {
        this.$toast.fail("所属社区、村不能为空");
        return;
      }
      if (!this.infoUnit.trim()) {
        this.$toast.fail("注册单位名称不能为空");
        return;
      }
      if (!this.infoAge) {
        this.$toast.fail("请选择年龄");
        return;
      }
      if (!this.infoCrowd) {
        this.$toast.fail("请选择人群类别");
        return;
      }
      if (!this.infoPhone.trim()) {
        this.$toast.fail("请输入手机号");
        return;
      }
      if (!/^(?:(?:\+|00)86)?1[3-9]\d{9}$/.test(this.infoPhone.trim())) {
        this.$toast.fail("请输入正确格式的手机号");
        return;
      }
      if (!this.infoSms.trim()) {
        this.$toast.fail("请输入短信验证码");
        return;
      }
      const isChange = this.infoDialogMode === "change";
      Dialog.confirm({
        title: "提示",
        message: isChange
          ? "确认提交修改后的参赛信息？"
          : "用户参赛信息提交后将无法修改，是否确认提交",
        confirmButtonColor: "#3a5bfc",
      })
        .then(async () => {
          try {
            const params = {
              name: this.infoUserName,
              province: "140000000000",
              city: this.infoCityCode,
              county: this.infoCountyCode,
              town: this.infoTownCode,
              age: this.infoAge,
              mobile: this.infoPhone,
              verify_code: this.infoSms.trim(),
              crowd: this.infoCrowd,
              village: this.infoVillage,
              unit: this.infoUnit,
            };
            await this.$axios.post(`/User/updateRegion`, params);
            this.user.province_code = "140000000000";
            this.user.name = this.infoUserName.trim();
            this.user.age = this.infoAge;
            this.user.city_code = this.infoCityCode;
            this.user.county_code = this.infoCountyCode;
            this.user.town_code = this.infoTownCode;
            this.user.village = this.infoVillage.trim();
            this.user.unit = this.infoUnit.trim();
            this.user.crowd = this.infoCrowd;
            this.user.mobile = this.infoPhone.trim();
            this.user.is_change = 2;
            this.$store.commit("user/SET_USER", this.user);
            this.infoDialog = false;
            this.$notify({
              type: "success",
              message: "提交成功",
              duration: 2000,
            });
          } catch (error) {
            this.$notify({
              type: "danger",
              message: error.errorMsg || "保存用户信息失败！",
              duration: 2000,
            });
            console.log(error);
          }
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
.index-wrap {
  position: relative;
  @include index-bg;

  // .index-logo {
  //   width: 203px;
  //   padding: 10px 106px 0 66px;

  //   img {
  //     width: 100%;
  //     vertical-align: top;
  //   }
  // }

  .index-label {
    min-height: 400px;
    margin-top: 82px;
    text-align: center;
    img {
      width: 100%;
      vertical-align: top;
    }
    .time-icon {
      width: 216px;
    }
    .sub-icon {
      width: 262px;
    }
  }

  .menu-wrap {
    padding: 0 40px;
    margin-top: -10px;
    .menu-item {
      width: 62px;
      height: 62px;
      cursor: pointer;
      &-center {
        width: 108px;
        height: 108px;
        cursor: pointer;
      }
    }

    @for $i from 1 through 3 {
      .bg-#{$i} {
        background: url("~@/assets/img/bg-#{$i}.png") no-repeat top center/100%;
      }
    }
  }
  .info-wrap {
    padding: 10px 30px 50px;
    font-size: 12px;
    line-height: 20px;
    color: #9c47fa;
    .van-row {
      align-items: baseline;
    }
    .info-label {
      position: relative;
      font-size: 12px;
      font-weight: 600;
      line-height: 20px;
    }
    .info-text {
      text-align: justify;
    }
  }
  .host-wrap {
    margin-top: 34px;
    text-align: center;
    img {
      width: 300px;
      vertical-align: top;
    }
  }
  .invite-btn-wrap {
    position: fixed;
    right: 0;
    bottom: 100px;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 120px;
    height: 40px;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    cursor: pointer;
    background: linear-gradient(135deg, #ff4d4f, #e02020);
    border-radius: 20px 0 0 20px;
    box-shadow: 0 2px 8px rgba(255, 0, 0, 0.3);
  }

  ::v-deep .van-dialog__footer::after {
    display: none;
  }

  .area-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 7px;
    margin-bottom: 12px;
    font-size: 13px;
    line-height: 18px;
    color: #666;
    cursor: pointer;
    border: 1px solid #efefef;
    border-radius: 3px 3px 3px 3px;
  }

  .area-disabled {
    color: #999;
    background: #efefef;
  }
  ::v-deep .edit-field {
    .van-field__control {
      color: #3b60fc !important;
    }
    .van-cell {
      background: #f0f6ff;
    }
  }

  ::v-deep .readonly-field {
    .van-field__control {
      color: #666 !important;
      text-align: right;
    }
    .van-field__value {
      color: #999 !important;
    }
  }

  ::v-deep .area-dialog {
    width: 318px;

    .van-dialog__header {
      padding-top: 20px;
      font-size: 20px;
      font-weight: 500;
      line-height: 25px;
      color: #333;
    }

    .area-dialog_content {
      .area-field {
        .van-field__control {
          color: #3b60fc;
        }
        .van-field__control--right {
          overflow: hidden;
          -o-text-overflow: ellipsis;
          text-overflow: ellipsis;
        }
      }

      .van-cell__right-icon {
        color: #3b60fc;
      }
    }

    .van-dialog__footer {
      display: none;
    }
  }
  .custom-dialog {
    .custom-dialog-main {
      padding: 20px 20px 50px;
      .custom-dialog-title {
        font-size: 20px;
        font-weight: 500;
        line-height: 25px;
        color: #333;
        text-align: center;
      }
      .custom-dialog-content {
        margin-top: 20px;
        font-size: 15px;
        line-height: 25px;
        color: #333;
        text-align: justify;
      }
    }
  }

  .time-count {
    position: absolute;
    top: 320px;
    right: 0;
    left: 0;
    width: 330px;
    padding: 0 0 20px;
    margin: auto;
    font-size: 14px;
    color: #fff;
    text-align: center;
    letter-spacing: 1px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 12px;
    box-shadow: rgba(0, 0, 0, 0.4) 0 2px 6px 0;

    p {
      margin: 20px 0;
    }

    .van-count-down {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .count-unit {
      display: flex;
      align-items: center;

      .block {
        display: inline-block;
        height: 32px;
        padding: 0 6px;
        margin: 0 1px;
        font-size: 17px;
        font-weight: 700;
        line-height: 32px;
        color: #000;
        text-align: center;
        background-color: #fff;
        border: 0.5px solid #333;
        border-radius: 4px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
      }

      .unit {
        margin-left: 2px;
        font-size: 13px;
        color: #fff;
      }
    }
  }
  .change-info-footer {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    padding: 8px 20px 12px;

    .footer-btn {
      flex: 1;
      height: 37px;
      font-size: 15px;
      color: #fff;
      background: linear-gradient(to right, #43a3f5, #3a5bfc);
      border: none;
      border-radius: 64px;
    }

    .cancel-btn {
      color: #666;
      background: #f5f5f5;
    }
  }

  .edit-hint {
    padding: 8px 16px;
    margin: 0 16px;
    font-size: 12px;
    color: #999;
    text-align: center;
  }
}
</style>
